<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- url="https://api-admin.nextdesign-e.com/api/v1/auth/uploadPhoto" @src-file-set="changePhoto"-->
<template>
  <div id="user-edit-tab-info">

    <!-- Content Row -->

    <div class="vx-row">
      <div class="vx-col md:w-1/2">
        <div data-v-13a23bd0="" v-if="viewMode && generalData.favicon !== null">
          <label class="vs-input--label"> Favicon </label>
          <div data-v-13a23bd0="" class="con-upload">
            <div class="con-img-upload">
              <div class="img-upload">
                <button type="button" class="btn-x-file" @click="closeImage"><i translate="translate" class="material-icons notranslate">clear</i></button>
                <img :src="generalData.favicon" style="max-width: 100%; max-height: none;" @click="clickImage(generalData.favicon)">
              </div>
              <div class="con-input-upload disabled-upload">
                <input type="file" accept="image/*" disabled="disabled"><span class="text-input">Upload File</span>
                <span class="input-progress" style="width: 0%;"></span>
                <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i translate="translate" class="material-icons notranslate">cloud_upload</i></button>
              </div>
            </div>
          </div>
        </div>

        <!-- v-else-if="(field.type_id === 21 && !viewMode[field.hash]) || (field.type_id === 21 && fieldModel[field.hash] === null)" -->

        <div
          v-else-if="!viewMode && generalData.favicon === null"
        >
          <label class="vs-input--label"> Favicon</label>
          <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'" :data="{application_token: $store.state.auth.app_token,session_token: $store.state.auth.token}" limit="1" single-upload @on-success="successUpload($event)" />
        </div>

      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Título da Aba no Navegador" v-model="generalData.tabTitle" @input="setTabTitle" name="web-tab" />
        <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

        <vs-input class="w-full mt-4" label="Mensagem de Boas Vindas ao Usuário no Telegram" v-model="generalData.telegramWelcomeMessage" @input="setTelegramWelcomeMessage" name="telegram-user-welcome-message" />
        <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full">

        <vs-input class="w-full mt-4" label="Rodapé" v-model="generalData.footer" @input="setFooter" name="footer" />
        <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

        <vs-input class="w-full mt-4" label="Telegram Bot Token" v-model="generalData.telegramBotToken" @input="setTelegramBotToken" name="telegram-bot-token" />
        <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/4 w-full">
        <ul class="con-s w-full mt-4">
          <li>
            <label class="vs-input--label">Sessões simultâneas</label>
            <vs-switch class="mt-2" v-model="generalData.simultaneousSessions" @input="setUsersCanSimultaneousSessions" />
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-1/4 w-full" style="margin-left: -15%!important;">
        <ul class="con-s w-full mt-4">
          <li>
            <label class="vs-input--label">Exclusão Lógica</label>
            <vs-switch class="mt-2" v-model="generalData.logicalExclusion" @input="setLogicalExclusion" />
          </li>
        </ul>
      </div>
    </div>

    <!-- <div class="mt-6">
      <label>Contact Options</label>
      <div class="flex flex-wrap mt-1">
      <vs-checkbox :value="this.$store.state.applicationManagement.userProfile.contacts" vs-value="email" @change="setUsername" class="mr-4 mb-2">Email</vs-checkbox>
      <vs-checkbox :value="this.$store.state.applicationManagement.userProfile.contacts" vs-value="message" @change="setUsername" class="mr-4 mb-2">Message</vs-checkbox>
      <vs-checkbox :value="this.$store.state.applicationManagement.userProfile.contacts" vs-value="phone" @change="setUsername" class=" mb-2">Phone</vs-checkbox>
      </div>
    </div> -->

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Salvar Alterações</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import myUpload from 'vue-image-crop-upload'
export default {
  components: {
    vSelect,
    'my-upload': myUpload
  },
  data () {
    return {

      viewMode: true,

      generalData: {
        tabTitle: '',
        footer: '',
        telegramWelcomeMessage: '',
        telegramBotToken: '',
        simultaneousSessions: false,
        logicalExclusion: false,
      },


      show: false,

      user_data: {
        // name: this.$store.state.applicationManagement.userProfile.name
      },

      update_avatar_data: null,

      data_local: null,

      // local_status: {label: this.$store.state.applicationManagement.userProfile.status_id, value: this.$store.state.applicationManagement.userProfile.status_name},

      local_role: 'admin',

      local_permissions: {
        comments: {read: true, write: false, create: true, delete: false},
        posts: {read: true, write: true, create: true, delete: true},
        users: {read: true, write: false, create: false, delete: false}
      },

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  created () {
    setTimeout(() => {
      this.generalData.favicon = this.$store.state.applicationManagement.settings.favicon
      this.generalData.tabTitle = this.$store.state.applicationManagement.settings.tabName
      this.generalData.footer = this.$store.state.applicationManagement.settings.footer
      this.generalData.telegramWelcomeMessage = this.$store.state.applicationManagement.settings.telegramWelcomeMessage
      this.generalData.telegramBotToken = this.$store.state.applicationManagement.settings.telegramBotToken
      this.generalData.simultaneousSessions = this.$store.state.applicationManagement.settings.simultaneousSessions
      this.generalData.logicalExclusion = this.$store.state.applicationManagement.settings.logicalExclusion
    }, 300)
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.local_status),  value: this.local_status  }
      },
      set (obj) {
        this.local_status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.local_role),  value: this.local_role  }
      },
      set (obj) {
        this.local_role = obj.value
      }
    },
    validateForm () {

      const specialRegex = new RegExp('^[0-9a-zA-Z ãâáàéêè\b]+$')

      return !this.errors.any()
    }
  },
  methods: {
    closeImage() {
      this.viewMode = !this.viewMode
      this.generalData.favicon = null
    },
    clickImage(imagePayload) {
      const div = document.createElement('div')
      div.classList.add('view-upload')

      const img = document.createElement('img')

      img.setAttribute('src', imagePayload)

      div.appendChild(img)
      document.querySelector('body').prepend(div)
    },
    successUpload(event) {
      const responseData = JSON.parse(event.srcElement.response)

      this.generalData.favicon = responseData.file_url
      this.$store.commit('applicationManagement/SET_FAVICON', responseData.file_url)
    },
    setTabTitle (e) {
      this.$store.commit('applicationManagement/SET_TAB_NAME', e)
    },
    setFooter (e) {
      this.$store.commit('applicationManagement/SET_FOOTER', e)
    },
    setTelegramWelcomeMessage (e) {
      this.$store.commit('applicationManagement/SET_TELEGRAM_WELCOME_MESSAGE', e)
    },
    setTelegramBotToken (e) {
      this.$store.commit('applicationManagement/SET_TELEGRAM_BOT_TOKEN', e)
    },
    setUsersCanSimultaneousSessions (e) {
      this.$store.commit('applicationManagement/SET_CAN_SIMULTANEOUS_SESSIONS', e)
    },
    setLogicalExclusion (e) {
      this.$store.commit('applicationManagement/SET_LOGICAL_EXCLUSION', e)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      this.$vs.loading({type: 'default'})

      this.$store.dispatch('applicationManagement/saveChanges', {userProfile: this.$store.state.applicationManagement.userProfile, apiUrl: this.$store.state.auth.api_url})
      .then(async (result) => {
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Operação Realizada!',
            text: `Dados alterados com sucesso!`,
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })
      })
      .catch((err) => {
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Erro',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
      })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    call_update_avatar () {
      // document.querySelector("#update_avatar").click()
      this.toggleShow()
    },
    validUrl (url) {
      setTimeout(() => {
        if (url) {
          if (url.split('.')[1] === 'png' || url.split('.')[1] === 'jpg' || url.split('.')[1] === 'jpeg') {
            return true
          } else {
            return false
          }
        }
      }, 300)
    },
    validBase64 (str) {
      setTimeout(() => {
        if (str) {
          if (str.substring(str.length - 2) === '==') {
            return /[A-Za-z0-9+/=]/.test(str)
          } else {
            return false
          }
        }
      }, 300)
    },
    update_avatar (e) {
      e.preventDefault()
      this.toggleShow()
      const preview = document.querySelector('img')
      const file = document.querySelector('input[type=file]').files[0]
      const reader = new FileReader()

      const me = this

      reader.addEventListener('load', function () {
        const btn_save = document.querySelector('#update_avatar_btn')
        btn_save.innerText = 'Salvar Alterações'
        const btn_cancel = document.querySelector('#remove_avatar')
        btn_cancel.innerText = 'Cancelar'
      }, false)

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    handlePreview (res, file) {
      this.changeImage(res.photo)
    },
    async changePhoto (imageDataUrl, field) {
      // console.log(imageDataUrl)
      this.$store.commit('applicationManagement/SET_PHOTO', imageDataUrl)
    }
  }
}
</script>
